import React from "react";
import PropTypes from "prop-types";

import "./ClickableEntry.scss";

const ClickableEntry = (props) => {
  const { clickable = true, label, onClickElt } = props;

  if (clickable) {
    return (
      <div
        className="clickable-entry"
        role="button"
        tabIndex="0"
        onClick={onClickElt}
      >
        {label}
      </div>
    );
  }
  return <div>{label}</div>;
};

ClickableEntry.propTypes = {
  clickable: PropTypes.bool,
  label: PropTypes.string,
  onClickElt: PropTypes.func.isRequired,
};

ClickableEntry.defaultProps = {
  clickable: true,
  label: "",
};

export default ClickableEntry;
